import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'fileExtension'})
export class GetFileExtensionPipe implements PipeTransform {
  constructor() {
  }

  transform(value: any): any {

    if (value.toString().includes(".")) {
      try {
        let valArr = value.split(".");
        return valArr[valArr.length - 1]
      } catch (e) {
        //
      }

    } return "file"
  }
}

